import React, { useEffect } from 'react';
import { useGlobalContext } from "../context/GlobalContext";

export const Logo = () => {
  const { setLightTheme, setNested } = useGlobalContext()

  useEffect(() => {
    setLightTheme(true);
    setNested(true)
  }, [])

  return (
    <React.Fragment>
      <div className="m-logo">
        <div className="m-logo__tab-container">
          <div className="m-logo__tab">
            <div className="m-logo__text">
              Logo design for 'Museum Pop UP', <br />an initiative by The Netherlands Institute for Sound and Vision.
              </div>
            <img className="lazyload m-logo__cover" src={require('../static/images/graphics/logo/logo_mupop.jpg')} alt="mupop logo" />
          </div>
          <div className="m-logo__tab">
            <div className="m-logo__text">
              Logo design for the company MGD control.
              </div>
            <img className="lazyload m-logo__cover" src={require('../static/images/graphics/logo/logo_mgd.jpg')} alt="mgd control logo" />
          </div>
          <div className="m-logo__tab">
            <div className="m-logo__text">
              Logo design concept for 'Twoj Metraz' - internet series about interior design.
              </div>
            <img className="lazyload m-logo__cover" src={require('../static/images/graphics/logo/logo_tm.jpg')} alt="tm logo" />
          </div>
          <div className="m-logo__tab">
            <div className="m-logo__text">
              Logo design concept for 'Creative Coding Salerno'
              </div>
            <img className="lazyload m-logo__cover" src={require('../static/images/graphics/logo/logo_ccs.png')} alt="ccs logo" />
          </div>
          <div className="m-logo__tab">
            <div className="m-logo__text">
              Redesign of ArtCafe logo.
              </div>
            <img className="lazyload m-logo__cover" src={require('../static/images/graphics/logo/logo_artcafe.jpg')} alt="artcafe logo" />
          </div>

        </div>
      </div>
    </React.Fragment>
  )
}